import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const SLIDER_HEIGHT_PX = 28;
export const TrackContainer = ({
  children,
  cursor = 'default',
  left,
  testId,
  width,
  zIndex = 5,
  onClick
}) => {
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetInlineStart: `${left * 100}%`,
    blockSize: `${SLIDER_HEIGHT_PX}px`,
    inlineSize: `${width * 100}%`,
    cursor: cursor,
    zIndex: zIndex,
    "data-test-id": testId,
    "data-acceptance-test": testId,
    onClick: onClick,
    children: children
  });
};